export enum PersonRedirect {
   REGISTER = 'REGISTER',
   DATA_SUPPLEMENTATION = 'DATA_SUPPLEMENTATION',
   MEMBERSHIP_VALIDATION = 'MEMBERSHIP_VALIDATION',
   NO_ACTION = 'NO_ACTION',
   VALID = 'VALID'
}
